import { render, staticRenderFns } from "./DialogMenuCreatePlayerLive.vue?vue&type=template&id=a48d1ea4&scoped=true"
import script from "./DialogMenuCreatePlayerLive.js?vue&type=script&lang=js&external"
export * from "./DialogMenuCreatePlayerLive.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48d1ea4",
  null
  
)

export default component.exports